import { Component, Input, SimpleChanges } from '@angular/core';
import { RecordsService } from '@modules/records/services/records.service';
import { Record, RecordServer } from '@modules/records/types/record';

@Component({
    selector: 'app-record-manual-upload',
    templateUrl: './record-manual-upload.component.html',
    styleUrl: './record-manual-upload.component.less',
    standalone: false
})
export class RecordManualUploadComponent {

  // Inputs
  @Input() record?: Record;
  @Input() serverId?: string;

  // Public
  public server?: RecordServer;
  public actions = {
    vod: {
      show: false,
      enabled: false,
      done: false
    },
    maxParity: {
      show: false,
      enabled: false,
      done: false
    },
    max: {
      show: false,
      enabled: false,
      done: false
    },
    linear: {
      show: false,
      enabled: false,
      done: false
    },
    contentAcquisition: {
      show: false,
      enabled: false,
      done: false
    },
    archive: {
      show: false,
      enabled: false,
      done: false
    }
  }

  /**
   * Constructor
   */

  constructor(
    private recordsService: RecordsService,
  ) { }

  /**
   * Component lifecycle
   */

  ngOnInit(): void {}

  ngOnChanges(changes: SimpleChanges): void {
    if ('record' in changes || 'serverId' in changes) {
      if (this.record && this.record.servers && this.serverId) {
        this.server = this.record.servers.find(server => server.id === this.serverId);
      } else {
        this.server = undefined;
      }
      this.updateActions();
    }
  }

  /**
   * Methods
   */

  updateActions(): void {
    // VOD
    this.actions.vod.show = !!this.server?.tasks.find(task => task.key === 'vodStartManualUpload');
    this.actions.vod.enabled = this.server?.tasks.find(task => ['vodTrim', 'vodTranscode'].includes(task.key))?.status === 'done';
    this.actions.vod.done = this.server?.tasks.find(task => task.key === 'vodStartManualUpload')?.status === 'done';
    // MAX Parity
    this.actions.maxParity.show = !!this.server?.tasks.find(task => task.key === 'maxParityStartManualUpload');
    this.actions.maxParity.enabled = this.server?.tasks.find(task => ['maxParityTrim', 'maxParityTranscode'].includes(task.key))?.status === 'done';
    this.actions.maxParity.done = this.server?.tasks.find(task => task.key === 'maxParityStartManualUpload')?.status === 'done';
    // MAX
    this.actions.max.show = !!this.server?.tasks.find(task => task.key === 'maxStartManualUpload');
    this.actions.max.enabled = this.server?.tasks.find(task => ['maxTrim', 'maxTranscode'].includes(task.key))?.status === 'done';
    this.actions.max.done = this.server?.tasks.find(task => task.key === 'maxStartManualUpload')?.status === 'done';
    // Linear
    this.actions.linear.show = !!this.server?.tasks.find(task => task.key === 'linearStartManualUpload');
    this.actions.linear.enabled = this.server?.tasks.find(task => ['linearTrim', 'linearTranscode'].includes(task.key))?.status === 'done';
    this.actions.linear.done = this.server?.tasks.find(task => task.key === 'linearStartManualUpload')?.status === 'done';
    // Content Acquisition
    this.actions.contentAcquisition.show = !!this.server?.tasks.find(task => task.key === 'contentAcquisitionStartManualUpload');
    this.actions.contentAcquisition.enabled = this.server?.tasks.find(task => ['contentAcquisitionTrim', 'contentAcquisitionTranscode'].includes(task.key))?.status === 'done';
    this.actions.contentAcquisition.done = this.server?.tasks.find(task => task.key === 'contentAcquisitionStartManualUpload')?.status === 'done';
    // Archive
    this.actions.archive.show = !!this.server?.tasks.find(task => task.key === 'archiveStartManualUpload');
    this.actions.archive.enabled = this.server?.tasks.find(task => ['archiveMetadata'].includes(task.key))?.status === 'done';
    this.actions.archive.done = this.server?.tasks.find(task => task.key === 'archiveStartManualUpload')?.status === 'done';
  }

  /**
   * Actions
   */

  upload(key: string): void {
    if (this.record?.id && this.serverId) {
      this.recordsService.startManualTask(this.record.id, [this.serverId], key);
    }
  }

}
